<template>
  <div class="open-account home">
    <FirstOpen v-if="status === 1"></FirstOpen>
    <Interrupt
      v-if="status === 2"
      :result="result"
      @reload="getData"></Interrupt>
    <InReview v-if="status === 3" :result="result"></InReview>
    <ChangeInfo v-if="status === 4" :result="result" @reload="handleRedirect"></ChangeInfo>
    <OpenResult v-if="status === 5" :result="result"></OpenResult>
  </div>
</template>

<script>
import FirstOpen from "./components/FirstOpen.vue";
import Interrupt from "./components/Interrupt.vue";
import InReview from "./components/InReview.vue";
import ChangeInfo from "./components/ChangeInfo.vue";
import OpenResult from "./components/OpenResult.vue";
import { getBrowser } from "@/utils/browser";
import { closeWebView, setStatementDetailInfo } from "@/utils/hybirdMethods";
export default {
  components: {
    FirstOpen,
    Interrupt,
    InReview,
    ChangeInfo,
    OpenResult
  },
  data() {
    return {
      status: 0, // 1 首次 2中断 3审核中 4 修改 5 结果(成功/失败)
      result: {
        errorData: ''
      },
    };
  },
  created() {
    if(getBrowser().isApp){
      setStatementDetailInfo({
        headerTitle: this.$route.meta.title,
        hideTitle: '0'
      })
    }
    this.getData();
  },
  methods: {
    getData() {
      this.$apis.accountSituationV2({
        hideFields: 'config_data'
      }).then(res => {
        if(getBrowser().isApp){
          setStatementDetailInfo({
            headerTitle: this.$route.meta.title,
            hideTitle: '0'
          })
          
        }
        
        // 添加简单的数据检查
        if (!res) {
          this.status = 1;  // 设置默认状态
          return;
        }

        const { account_status, process_info } = res;
        // account_status 0 =》 分两种  看process_info： 没数据 == 1  有数据 == 2
        // account_status 2 6 首次开户信息提交 == 审核中 3
        // account_status 3 不通过  4
        // account_status 1/4/5 结果(开户成功/没账户/没入金)  5
        this.result = res;
        // this.status = 2;
        // return;
        if(account_status == 0 || account_status == 21){
          this.status = 1;
          if(process_info?.['2-1'] || process_info?.['2-2']){
            this.status = 2;
          }
        }
        else if(account_status == 2 || account_status == 6){
          this.status = 3;
        }
        else if(account_status == 3){
          //   不通过的原因的列表
          //   个人原因 看接口返回
          // 机构的 固定原因 就是不通过 联系客服
          if(res.open_method == 1){
            this.$apis.getFailInfo().then(res => {
              this.result.errorData = res; // 失败的原因
              this.status = 4;
            })
          }else{
            this.status = 4;
          }
          if(getBrowser().isApp){
            setStatementDetailInfo({
              headerTitle: $t('fail_reason.nav_title'),
              hideTitle: '0'
            })
          }
        }

        else if([1,4,5,16,19,8,7,12].includes(account_status)){
          this.status = 5;
        }
      })
    },
    // app直接返回，h5重新获取状态
    handleRedirect() {
      const browser = getBrowser()
      const isAPP = browser.isApp;
      if( isAPP ){
        closeWebView();
      }else{
        this.getData();
      }
    }
  }
};
</script>

<style scoped lang="less">
.open-account{
  background: #fff;
  min-height: 100%;
}
.black-theme .open-account{
  background: #1B1C24;
}
</style>
